export { errorMessage } from '../../customers/common/customer-common'

export const COMPANY_BACK_PATH = '/configuracion'
